import {
  GALLERY_STATUS_REQUEST,
  GALLERY_STATUS_SUCCESS,
  GALLERY_STATUS_FAILURE,
} from "../../actions/types";

// reducer.js
const initialState = {
  isLoading: false,
  response: null,
  error: null,
};

export const galleryStatusReducer = (state = initialState, action) => {
  switch (action.type) {
    case GALLERY_STATUS_REQUEST:
      return { ...state, isLoading: true, response: null, error: null };
    case GALLERY_STATUS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        response: action.payload,
        error: null,
      };
    case GALLERY_STATUS_FAILURE:
      return {
        ...state,
        isLoading: false,
        response: null,
        error: action.payload,
      };
    default:
      return state;
  }
};
